module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKFJREFUeNq8klEKwkAMRGd7AY+g/654D6+u1SP4I1Sjd4gpTCFkS8u6YOB97DADk7RQVTi2xl3LGbWd96ZRxQ/TFERLsDad/h/sZsSr8XHvt3ErXPwu05yNjXE0hGRqF+crgi9jT+3AEKjJUjCGwbAED+Z2TEYX3ljbUVhxqpdd7cWqPQ+Ra4+jNEho0ccdm3+AoSL09Mc5GYOuz4NefAUYAB1/r5QwljCkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/delete-btn.png
// module id = 1504
// module chunks = 0